import type { Dict, Faq } from '@/i18n';

/**
 * Une seule source pour les questions : `faqGroups`. La landing n'en garde que
 * celles qui portent un rang `top`, dans l'ordre de ce rang — pas de seconde
 * copie du texte qui divergerait de la page `/faq`.
 */
export function allFaqs(t: Dict): Faq[] {
  return t.faqGroups.flatMap((group) => group.items);
}

export function landingFaqs(t: Dict): Faq[] {
  return allFaqs(t)
    .filter((faq) => faq.top !== undefined)
    .sort((a, b) => (a.top ?? 0) - (b.top ?? 0));
}
